const reservationUrl = 'https://book.squareup.com/appointments/hqjlguwjlxeenh/location/MH09XMWCMM5H9/services';
const lineOfficialUrl = 'https://lin.ee/qXeHGgH';

const docRoutes = {
    concept: '/concept',
    treatments: '/treatments',
    menu: '/menu',
    symptoms: '/symptoms',
    symptomsLowBackPain: '/symptoms/low-back-pain',
    symptomsShoulderPain: '/symptoms/shoulder-pain',
    symptomsNeckPain: '/symptoms/neck-pain',
    symptomsKneePain: '/symptoms/knee-pain',
    reservation: '/reservation',
    access: '/access',
    campaignNerveTherapy: '/campaign/nerve-therapy-trial',
    campaignFacialCare: '/campaign/facial-care',
    campaignFullBodyBalance: '/campaign/full-body-balance'
};

const sectionMenuItems = [
    { id: 'hero', label: 'トップ', targetId: 'hero', fallbackTo: '/' },
    { id: 'body-care', label: '痛みと向き合う', targetId: 'body-care', fallbackTo: '/' },
    { id: 'concept', label: 'コンセプト', targetId: 'concept', fallbackTo: '/' },
    { id: 'features', label: '特徴', targetId: 'features', fallbackTo: '/' },
    { id: 'treatment', label: '施術方針', targetId: 'treatment', fallbackTo: '/' },
    { id: 'reviews', label: 'お客様の声', targetId: 'reviews', fallbackTo: '/' },
    { id: 'campaign', label: 'キャンペーン', targetId: 'campaign', fallbackTo: '/' },
    { id: 'access', label: 'ご予約・アクセス', targetId: 'access', fallbackTo: '/' }
];

const detailMenuItems = [
    { id: 'top-page', label: 'トップ', to: '/' },
    {
        id: 'concept-group',
        label: 'コンセプト・施術',
        items: [
            { id: 'concept-page', label: 'コンセプト詳細', to: docRoutes.concept },
            { id: 'treatments-page', label: '当院の施術', to: docRoutes.treatments }
        ]
    },
    {
        id: 'menu-group',
        label: 'メニュー',
        items: [
            { id: 'menu-page', label: 'メニュー一覧', to: docRoutes.menu },
            { id: 'campaign-nerve-therapy', label: '神経整体お試し', to: docRoutes.campaignNerveTherapy },
            { id: 'campaign-facial-care', label: '小顔施術', to: docRoutes.campaignFacialCare },
            { id: 'campaign-full-body', label: '全身バランス調整', to: docRoutes.campaignFullBodyBalance }
        ]
    },
    {
        id: 'symptoms-group',
        label: '症状別',
        items: [
            { id: 'symptoms-page', label: '症状別ガイド', to: docRoutes.symptoms },
            { id: 'symptoms-neck', label: '首の痛み', to: docRoutes.symptomsNeckPain },
            { id: 'symptoms-shoulder', label: '肩こり・五十肩', to: docRoutes.symptomsShoulderPain },
            { id: 'symptoms-low-back', label: '腰痛', to: docRoutes.symptomsLowBackPain },
            { id: 'symptoms-knee', label: '膝の痛み', to: docRoutes.symptomsKneePain }
        ]
    },
    { id: 'access-page', label: 'アクセス', to: docRoutes.access },
    { id: 'reservation-page', label: 'ご予約・お問い合わせ', to: docRoutes.reservation }
];

const cloneMenuItems = (items = []) =>
    items.map(({ items: childItems, ...rest }) => ({
        ...rest,
        ...(childItems ? { items: cloneMenuItems(childItems) } : {})
    }));

const createMenuItems = ({ includeSections = false } = {}) =>
    detailMenuItems.map((item) => {
        if (item.id === 'top-page') {
            if (!includeSections) {
                return { ...item };
            }

            return {
                ...item,
                items: cloneMenuItems(sectionMenuItems)
            };
        }

        if (item.items) {
            return {
                ...item,
                items: cloneMenuItems(item.items)
            };
        }

        return { ...item };
    });

export {
    reservationUrl,
    lineOfficialUrl,
    docRoutes,
    sectionMenuItems,
    detailMenuItems,
    createMenuItems
};

